module.exports = __webpack_public_path__ + "static/media/document-xls.e734a841.svg";